import {
  FormProps,
  LinkClickProps,
  OnSiteSearchProps,
  PageScrollProps,
  PageViewProps,
} from '@/hooks/AdobeAnalyticsHooks/types/AdobeAnalyticsTypes';
import { AdobeAnalyticsConst } from '@/hooks/AdobeAnalyticsHooks/adobeAnalyticsConstants/adobeAnalyticsConstants';
import { createContext } from 'react';

interface AnalyticsContextValue {
  trackUserRegistration: (props: FormProps) => void;
  trackOnSiteSearch: (props: OnSiteSearchProps) => void;
  trackPageView: (props: PageViewProps) => void;
  trackScrollEvent: (props: PageScrollProps) => void;
  trackLinkClick: (props: LinkClickProps) => void;
  adobeAnalyticsConst: typeof AdobeAnalyticsConst;
}

const AdobeAnalyticsContext = createContext<AnalyticsContextValue | null>(null);

export default AdobeAnalyticsContext;
